import { testimonials } from '../../../mocks/testimonials';
import { useInView } from '../../../hooks/useInView';

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#0F7C7A] text-sm" />
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const { ref, inView } = useInView();

  return (
    <section id="depoimentos" className="py-24 bg-[#0F7C7A]">
      <div ref={ref} className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className={`text-center mb-16 ${inView ? 'animate-fade-in-up' : 'opacity-0-init'}`}>
          <p className="text-[#7FCECC] text-sm font-semibold tracking-[0.2em] uppercase mb-3">
            Depoimentos
          </p>
          <h2 className="font-display text-4xl lg:text-5xl text-white font-bold mb-4">
            O Que Nossas{' '}
            <span className="italic text-[#7FCECC]">Clientes</span> Dizem
          </h2>
          <p className="text-white/75 text-base max-w-lg mx-auto">
            Histórias reais de mulheres que transformaram sua rotina de beleza com os nossos produtos.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={t.id}
              className={`bg-white rounded-2xl p-6 border border-[#DFF0F0] flex flex-col ${
                inView ? `animate-scale-in delay-${idx * 100}` : 'opacity-0-init'
              }`}
            >
              {/* Quote icon */}
              <div className="w-8 h-8 flex items-center justify-center mb-4">
                <i className="ri-double-quotes-l text-3xl text-[#0F7C7A]/30" />
              </div>

              <StarRating count={t.rating} />

              <p className="text-[#333333] text-sm leading-relaxed mt-3 mb-5 flex-1">
                &ldquo;{t.comment}&rdquo;
              </p>

              <div className="border-t border-[#DFF0F0] pt-4">
                <div className="text-[#0F7C7A] text-xs font-semibold mb-3">{t.product}</div>
                <div className="flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover object-top"
                  />
                  <div>
                    <p className="text-[#1A1A1A] font-semibold text-sm">{t.name}</p>
                    <p className="text-[#555555] text-xs">{t.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust badges */}
        <div className={`mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6 ${inView ? 'animate-fade-in-up delay-500' : 'opacity-0-init'}`}>
          {[
            { icon: 'ri-shield-check-line', value: '4.9/5', label: 'Avaliação Média' },
            { icon: 'ri-user-heart-line', value: '98%', label: 'Satisfação' },
            { icon: 'ri-refresh-line', value: '30 dias', label: 'Garantia' },
            { icon: 'ri-truck-line', value: 'Grátis', label: 'Frete acima de R$150' },
          ].map((badge) => (
            <div
              key={badge.label}
              className="bg-white/10 rounded-2xl p-5 border border-white/10 flex items-center gap-4"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white/15 rounded-xl">
                <i className={`${badge.icon} text-xl text-[#7FCECC]`} />
              </div>
              <div>
                <p className="font-display text-lg font-bold text-white">{badge.value}</p>
                <p className="text-white/70 text-xs">{badge.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
